<div class="pn-wrap">
  <div class="pn-header">
    <h2 class="pn-title">{{ 'notifications' | translate }}</h2>
    <button type="button" class="pn-mark-all-btn" *ngIf="items.length" (click)="requestMarkAllRead()">
      <i class="ri-check-double-line"></i> {{ 'markAllRead' | translate }}
    </button>
  </div>

  <div class="pn-error" *ngIf="error">{{ error }}</div>

  <div class="pn-list" *ngIf="!loading; else pnLoading">
    <div class="pn-empty" *ngIf="!items.length && !error">
      <div class="pe-icon"><i class="ph ph-folder-open"></i></div>
      <div class="pe-title">{{ 'dataNotFound' | translate }}</div>
    </div>

    <ng-container *ngFor="let section of sections">
      <div class="pn-section-title">{{ section.label | translate }}</div>
      <div class="pn-card" *ngFor="let item of section.items; trackBy: trackByNotificationId" (click)="openNotification(item)">
        <div class="pn-card-accent"></div>
        <div class="pn-card-body">
          <div class="pn-card-top">
            <div class="pn-card-title">{{ item.notifyAbout }}</div>
            <button type="button" class="pn-read-btn" title="{{ 'markAsRead' | translate }}" (click)="requestMarkRead(item, $event)">
              <i class="ri-check-line"></i>
            </button>
          </div>
          <div class="pn-card-message">{{ item.message }}</div>
          <div class="pn-card-date">{{ item.notifiedOn | date: 'dd MMM, y, h:mm a' }}</div>
        </div>
      </div>
    </ng-container>
  </div>

  <ng-template #pnLoading>
    <div class="pn-list">
      <div class="pn-card pn-card-skeleton" *ngFor="let n of [1,2,3,4,5,6]"></div>
    </div>
  </ng-template>

  <div class="pn-pagination" *ngIf="!loading && items.length && maxPageNumber > 1">
    <button type="button" class="pn-page-btn" [disabled]="currentPage <= 1" (click)="goToPrevPage()">
      <i class="ri-arrow-left-s-line"></i> {{ 'previous' | translate }}
    </button>
    <span class="pn-page-indicator">{{ currentPage }} / {{ maxPageNumber }}</span>
    <button type="button" class="pn-page-btn" [disabled]="currentPage >= maxPageNumber" (click)="goToNextPage()">
      {{ 'next' | translate }} <i class="ri-arrow-right-s-line"></i>
    </button>
  </div>
</div>

<!-- Mark-as-read confirmation — stands in for the mobile app's confirmation bottom sheet -->
<div class="pn-confirm-overlay" *ngIf="confirmTarget" (click)="cancelConfirm()">
  <div class="pn-confirm-box" (click)="$event.stopPropagation()">
    <div class="pn-confirm-icon"><i class="ri-check-double-line"></i></div>
    <div class="pn-confirm-text">
      {{ (confirmTarget === 'All' ? 'markAllNotificationsAsRead' : 'markThisNotificationAsRead') | translate }}
    </div>
    <div class="pn-confirm-actions">
      <button type="button" class="pn-confirm-cancel" (click)="cancelConfirm()">{{ 'cancel' | translate }}</button>
      <button type="button" class="pn-confirm-ok" (click)="confirmMarkRead()">{{ 'markAsRead' | translate }}</button>
    </div>
  </div>
</div>
